<template>
  <div id="Color"/>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, watchEffect, onUnmounted, onMounted} from 'vue'

import defaultValue from "@/utils/defaultValue"
import colorTool from "@/utils/colorTool"

const {defaultWidth, defaultHeight} = defaultValue()
const {changeToRgb} = colorTool()


const props = defineProps(['currentValue', 'effectTheme'])

const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')
let colorType = ref('')
let sensorValue = reactive({}) // 取得sensor資料

let solidColor = ref('rgb(0,0,0)')
let linearGradientColors = reactive({arr: ['rgb(0, 60, 100)', 'rgb(180, 40, 80)']})

function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}
const colorAnimate = (sketch) => {
  let cw = defaultWidth.value
  let ch = defaultHeight.value

  sketch.setup = function() {
    sketch.createCanvas(cw, ch)
    sketch.frameRate(10)
    sketch.noStroke()
  }

  sketch.draw = function() {
    sketch.clear()
    if (colorType.value === 'SolidColor') sketch.background(solidColor.value)
    else if (colorType.value === 'RadialGradient') setRing(sketch.width, sketch.height, sketch.color(linearGradientColors.arr[0]), sketch.color(linearGradientColors.arr[1]))
    else setGradient(
          sketch.width,
          sketch.height,
          sketch.color(linearGradientColors.arr[0]),
          sketch.color(linearGradientColors.arr[1]),
          colorType.value
      )

    sketch.noLoop()
  }

  function setRing(w,h,c1,c2) {
    let centerX = w / 2;
    let centerY = h / 2;
    // 計算 中心點 到 邊 距離
    let maxRadius = sketch.dist(0, 0, centerX, centerY);

    for (let r = maxRadius; r > 0; r -= 2) {
      let inter = sketch.map(r, 0, maxRadius, 0, 1);
      let c = sketch.lerpColor(
          c1,
          c2,
          inter
      )
      sketch.fill(c)
      sketch.ellipse(centerX, centerY, r * 2, r * 2)
    }
  }

  function setGradient(w, h, c1, c2, colorType) {
    sketch.noFill()

    if (colorType === 'VerticalGradient') {
      // 从上到下的渐变
      for (let i = 0; i <= 0 + h; i++) {
        let inter = sketch.map(i, 0, h, 0, 1)
        let c = sketch.lerpColor(c1, c2, inter);
        sketch.stroke(c)
        sketch.line(0, i, w, i)
      }
    } else if (colorType === 'HorizontalGradient') {
      // 从左到右的渐变
      for (let i = 0; i <= 0 + w; i++) {
        let inter = sketch.map(i, 0, w, 0, 1)
        let c = sketch.lerpColor(c1, c2, inter)
        sketch.stroke(c)
        sketch.line(i , 0, i, h)
      }
    }
  }
}



watchEffect(() => {
  const {
    ColorType,
    Colors,
    Flip
  } = effectThemeData
  colorType.value = ColorType
  if (ColorType === 'SolidColor') {
    solidColor.value = typeof Colors === "object" && Colors.length > 0 ? changeToRgb(Colors[0]) : 'rgb(0,0,0)'
    if (canvasWrap.value !== 'stop') {
      initAnimate()
      canvasWrap.value = new p5(colorAnimate, 'Color')
    }
  } else {
    linearGradientColors.arr = Colors.map(c => changeToRgb(c))
    if (Flip) linearGradientColors.arr = Colors.map(c => changeToRgb(c)).reverse()
    // create p5
    if (canvasWrap.value !== 'stop') {
      initAnimate()
      canvasWrap.value = new p5(colorAnimate, 'Color')
    }
  }

})


onMounted(() => {
  if (canvasWrap.value === 'stop') canvasWrap.value = new p5(colorAnimate, 'Color')
})

onUnmounted(() => {
  solidColor.value = 'rgb(0,0,0)'
  linearGradientColors.arr = ['rgb(0, 60, 100)', 'rgb(180, 40, 80)']
  colorType.value = ''
  initAnimate()
})

</script>
